<template>
  <div class="col-sm-12 header-component mb16 flex-row" id="pageTop">
    <home-page-user-address></home-page-user-address>
    <reward-program></reward-program>
    <!-- Profile Icon -->
    <div :class="{ hide: !isOnStorePage }">
      <div
        class="profile-icon flex-column"
        @click="handleProfileIconClick($event)"
      >
        <span><i class="jfi-user fs-18"></i></span>
      </div>
      <profile-drawer-modal
        v-if="showProfileDrawerModal || loadProfileDrawerModal"
        :data-left-menu-links="dataResults"
        :showProfileDrawerModal="showProfileDrawerModal"
        @close-profile-modal="closeProfileModal()"
      ></profile-drawer-modal>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import HomePageUserAddress from "./HomePageUserAddress.vue";
import RewardProgram from "./RewardProgram.vue";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import UserActivityTracking from "../helpers/UserActivityTracking";

export default {
  name: "TopBar",
  components: {
    HomePageUserAddress,
    RewardProgram,
    ProfileDrawerModal: defineAsyncComponent(() =>
      import(/* webpackPrefetch: true */ "./ProfileDrawerModal.vue")
    ),
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      isOnStorePage: (window.location.href.search(Utility.storeRegex) > -1),
      showProfileDrawerModal: false,
      loadProfileDrawerModal: false,
    };
  },
  mounted() {
    UserActivityTracking.pageView(0,"homePageView");
    setTimeout(() => {
      this.loadProfileDrawerModal = true;
    }, 10000);
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      const isLogged = this.isLoggedIn ? "yes" : "no";
      let preEventObj = { category: "profile", loginStatus: isLogged, ...eObj };
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "topbar",
        "1",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    handleProfileIconClick() {
      //Amplitude click event load
      this.eventFunction(true);
      this.showProfileDrawerModal = true;
      //Amplitude impression event load
      this.eventFunction(false, { actionType: "hamburger menu" });
      UserActivityTracking.hamburgerMenuView(0);
    },
    closeProfileModal() {
      this.showProfileDrawerModal = false;
    },
  },
  computed: {
    isLoggedIn() {
      let _ = this.$store.state.Auth.isLoggedIn;
      this.links = JSON.parse(this.dataResults)?.filter((__) => {
        return !(!_ && __.name == "My Wallet");
      });
      return _;
    },
  },
};
</script>
